import { FaAngleDoubleRight } from 'react-icons/fa';

const Duty = (props)=>
{
    const {duty} = props;
    return (
    <div className="job-desc">
        <FaAngleDoubleRight className="job-icon"></FaAngleDoubleRight>
        <p>{duty}</p>
    </div>);
}

export default Duty;